import { BreakpointObserver } from "@angular/cdk/layout";
import { DatePipe, LowerCasePipe } from "@angular/common";
import { Component, computed, inject, signal, TemplateRef, viewChild } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { RouterLink } from "@angular/router";
import { EventReportDatePipe, LocalDatePipe } from "@kno2/common/pipes";
import { APP_CONFIG_TOKEN } from "@kno2/core/config";
import { SessionService } from "@kno2/core/session";
import { RequestInfo, RequestInfoQuery, UsersService } from "@kno2/data-access/users";
import { MultiAddressSnippetComponent } from "@kno2/shared/multi-address-snippet";
import { PaginationComponent } from "@kno2/shared/pagination";
import { TableColumn, TableComponent } from "@kno2/shared/table/table.component";
import { map } from "rxjs";

@Component({
    selector: "kno2-request-history",
    imports: [TableComponent, PaginationComponent, MultiAddressSnippetComponent, RouterLink, LowerCasePipe, LocalDatePipe, DatePipe, EventReportDatePipe],
    templateUrl: "./request-history.component.html"
})
export class RequestHistoryComponent {
    private readonly appConfig = inject(APP_CONFIG_TOKEN);
    private readonly sessionService = inject(SessionService);
    private readonly usersService = inject(UsersService);
    private readonly breakpointObserver = inject(BreakpointObserver);
    private showAllColumns = toSignal(this.breakpointObserver.observe("(min-width: 992px)").pipe(map((result) => result.matches)));

    protected brandDisplayName = this.appConfig.brandDisplayName;
    protected statusTemplate = viewChild<TemplateRef<{ request: unknown }>>("status");
    protected dateSubmittedTemplate = viewChild<TemplateRef<{ request: unknown }>>("dateSubmitted");
    protected mailToTemplate = viewChild<TemplateRef<{ request: unknown }>>("mailTo");

    protected queryOptions = signal({
        pageSize: 10,
        pageStart: 1
    });

    protected requests = this.usersService.getRequests(this.sessionService.profileData().userId, this.queryOptions);
    protected columns = computed(() => this.getColumns());

    public paginationChange(options: RequestInfoQuery): void {
        this.queryOptions.update((currentOptions) => ({ ...currentOptions, ...options }));
    }

    private getColumns(): TableColumn<RequestInfo>[] {
        return [
            {
                field: "status",
                cellClass: "overflow-visible",
                templateRef: this.statusTemplate()
            },
            {
                field: "dateSubmitted",
                isHidden: !this.showAllColumns(),
                cellClass: "overflow-visible",
                width: "15%",
                templateRef: this.dateSubmittedTemplate()
            },
            {
                field: "mailTo",
                headerText: "To",
                cellClass: "k2-ellipsis",
                width: "25%",
                templateRef: this.mailToTemplate()
            },
            {
                field: "requestor",
                cellClass: "k2-ellipsis"
            },
            {
                field: "senderName",
                headerText: "User",
                cellClass: "k2-ellipsis"
            },
            {
                field: "patientName",
                headerText: "Patient",
                cellClass: "k2-ellipsis"
            }
        ];
    }
}
